import type { ReactNode } from "react";

type UnavailableOverlayProps = {
  active: boolean;
  children: ReactNode;
};

export const UnavailableOverlay = ({ active, children }: UnavailableOverlayProps) => (
  <div className="relative min-w-0">
    {active && (
      <div className="absolute inset-0 z-10 rounded-lg bg-white/60 backdrop-blur-[2px] dark:bg-slate-950/50" />
    )}
    <div className={`min-w-0${active ? " pointer-events-none select-none" : ""}`}>
      {children}
    </div>
  </div>
);
